import { AlertTriangle } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

/**
 * When AuthContext can't load the trusted profile row, the app blocks portal
 * access and shows a retry affordance instead of guessing a role or tenant
 * from the user's email domain.
 */
export function AuthFallbackBanner() {
  const { fallback, refreshProfile } = useAuth();
  if (!fallback) return null;

  return (
    <div
      role="alert"
      aria-live="assertive"
      className="fixed inset-x-0 top-0 z-[90] flex items-center justify-center gap-3 border-b border-[#553f1c] bg-[#3a2a13] px-4 py-2 text-warning"
    >
      <AlertTriangle className="h-4 w-4 shrink-0" aria-hidden="true" />
      <span className="text-xs">
        We couldn't fully load your account. Retry to restore access once your
        trusted profile is available.
      </span>
      <button
        type="button"
        onClick={() => refreshProfile()}
        className="rounded border border-[#553f1c] px-2 py-0.5 text-xs font-semibold hover:bg-[#4a3618]"
      >
        Retry
      </button>
    </div>
  );
}
